import React from 'react';

/**
 * Contrôles de pagination incrémentale pour les listes du dashboard.
 * Affiche un bouton « Afficher N de plus » et un bouton « Réduire » selon l'état.
 *
 * @param {number} visible  - nombre de lignes actuellement affichées
 * @param {number} total    - nombre total de lignes disponibles
 * @param {number} pageSize - palier d'incrément
 * @param {Function} onMore - callback pour afficher plus
 * @param {Function} onReset- callback pour réduire au palier initial
 * @param {string} testid   - préfixe data-testid
 * @param {string} colorClass - classes Tailwind de bordure/texte (thème de l'onglet)
 */
export const ShowMoreControls = ({ visible, total, pageSize, onMore, onReset, testid, colorClass = 'border-[#397DFF] text-[#397DFF] hover:bg-[#397DFF]' }) => {
  if (total <= pageSize) return null;
  const remaining = total - visible;
  return (
    <div className="flex items-center gap-2">
      {visible < total && (
        <button
          data-testid={`${testid}-more`}
          onClick={onMore}
          className={`text-sm px-3 py-1.5 rounded-lg border ${colorClass} hover:text-white transition`}
        >
          Afficher {Math.min(pageSize, remaining)} de plus ({remaining} restant{remaining > 1 ? 's' : ''})
        </button>
      )}
      {visible > pageSize && (
        <button
          data-testid={`${testid}-reset`}
          onClick={onReset}
          className="text-sm px-3 py-1.5 rounded-lg border border-[#BFC6CC] text-[#687175] hover:bg-[#F5F6F9] transition"
        >
          Réduire
        </button>
      )}
    </div>
  );
};

export default ShowMoreControls;
